import { render } from "./produtoForm.vue?vue&type=template&id=c0cde012&scoped=true"
import script from "./produtoForm.vue?vue&type=script&lang=js"
export * from "./produtoForm.vue?vue&type=script&lang=js"

import "./produtoForm.vue?vue&type=style&index=0&id=c0cde012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0cde012"]])

export default __exports__